import { FC } from 'react';
import { Link } from 'react-router-dom';

import { Typography } from '@mui/material';

import OpenSourceButton from '@src/main/ui/components/common/Dashboard/common/buttons/OpenSourceButton/OpenSourceButton';

interface Props {
  url: string;
}

const NonEmbeddable: FC<Props> = ({ url }) => (
  <Typography variant="h5" sx={{ marginTop: '30px', textAlign: 'center' }}>
    Content not available for embedding, you can open the requested dashboard by clicking here
    <Link to={url} target="_blank">
      <OpenSourceButton fontSize="30px" />
    </Link>
  </Typography>
);

export default NonEmbeddable;
